import { LoginPageComponent } from './features/auth/login-page/login-page.component';
import { Routes } from '@angular/router';
import { loggedInAuthGuard } from './core/guard/logged-in-auth.guard';
import { authGuard } from './core/guard/auth.guard';
import { ForgetPasswordComponent } from './features/auth/forget-password/forget-password.component';
import { ResetPasswordComponent } from './features/auth/reset-password/reset-password.component';
import { UnsubscribeComponent } from './features/auth/unsubscribe/unsubscribe.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'unsubscribe/:email',
    component: UnsubscribeComponent,
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/authenticated.routes').then((m) => m.authenticatedRoutes),
  },
];

